module.exports = __webpack_public_path__ + "media/EG3D-Home-BG-sm.f8aa2717.mp4";